import { render, staticRenderFns } from "./ConfirmRemoveMember.vue?vue&type=template&id=764d459c&"
import script from "./ConfirmRemoveMember.vue?vue&type=script&lang=js&"
export * from "./ConfirmRemoveMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports